import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dragmenu",
  "use": "icon-dragmenu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-dragmenu\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M9.5,5.83A1.5,1.5,0,1,0,11,7.33,1.51,1.51,0,0,0,9.5,5.83Zm0,9.34a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,9.5,15.17Zm5,0a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,14.5,15.17Zm-5-4.67A1.5,1.5,0,1,1,8,12,1.51,1.51,0,0,1,9.5,10.5Zm5,0A1.5,1.5,0,1,1,13,12,1.51,1.51,0,0,1,14.5,10.5Zm0-4.67A1.5,1.5,0,1,1,13,7.33,1.51,1.51,0,0,1,14.5,5.83Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol